// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.everspace",
    name: "Everspace",
    homepage: "https://everspace.app",
    image_id: "80eaa630-6392-4b0a-a604-0a0f808e4d00",
    app: {
        browser: "https://everspace.app/",
        ios: "https://apps.apple.com/ru/app/everspace/id1585434994?l=en",
        android: "https://play.google.com/store/apps/details?id=com.oberton.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "everspace://",
        universal: "https://everspace.app/deeplink",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map